export class SearchParamsUtils {

	static getFlightClassByCode(code: number): string {
		const flightClasses = [ 'Económica', 'Premium economy', 'Ejecutiva/Business' ];
		return flightClasses[code] ?? '';
	}
}
